import ChartComponent from "./ChartComponent";
import React from 'react';
import * as d3 from 'd3';

const VerticalGridLines = ({ yScale, numberOfTicks, width, color = 'lightgrey', opacity = 0.25 }) => {
    function makeGridLines() {
        return d3.axisLeft(yScale).ticks(numberOfTicks).tickSize(-width).tickFormat("");
    }

    function draw(chart) {
        chart.append('g')
            .attr('stroke', color)
            .attr('opacity', opacity)
            .call(makeGridLines());
    }

    return (
        <ChartComponent
            draw={draw}
        />
    )
}

export default VerticalGridLines
